import { Table, TableCol, TablePagination } from 'zens-storybook'
import React from 'react'
import { StyleSheet, ViewProps } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Zone, useZones } from 'zens-store'

import { TablePaginated } from '../table'
import { BuildingField } from '../building'

import ZoneEmpty from './empty'

const styles = StyleSheet.create({
  building: {
    marginLeft: 0,
    marginTop: 0,
  },
})

interface Data {
  data: Zone
  onPress?: () => void
}

interface Props {
  companyId: number
  search?: string
  pagination?: TablePagination
  onPaginationChange?: (pagination: TablePagination) => void
}

const ZoneTable = (props: Props) => {
  const { companyId, search, pagination = { page: 0, size: 10 }, onPaginationChange } = props
  const zones = useZones({ companyId, search })
  const { t } = useTranslation()

  const cols: TableCol<Zone>[] = [
    {
      key: 'name',
      title: t('Zone name'),
    },
    {
      key: 'location',
      title: t('Location'),
      render: (zone: Zone) => (
        <BuildingField value={zone.buildingId || 0} companyId={companyId} style={styles.building} />
      ),
    },
    {
      key: 'numberOfWorkspaces',
      title: t('Workspace count'),
    },
  ]

  const rows: Data[] =
    zones.data?.map((zone) => ({
      data: zone,
      href: `/companies/${companyId}/workspaces/zones/${zone.id}`,
    })) || []

  return (
    <TablePaginated
      rows={rows}
      cols={cols}
      pagination={pagination}
      count={rows.length}
      renderCount={() =>
        t('{{page}} of {{numberOfPages}}', {
          page: pagination.page + 1,
          numberOfPages: Math.ceil(rows.length / pagination.size),
        })
      }
      sizeLabel={t('Zones per page')}
      maxSize={1000}
      onPaginationChange={onPaginationChange}
      ListEmptyComponent={<ZoneEmpty search={search} companyId={companyId} />}
    />
  )
}

interface SkeletonProps extends ViewProps {}

const Skeleton = (props: SkeletonProps) => {
  const { t } = useTranslation()

  const cols: TableCol<Zone>[] = [
    {
      key: 'name',
      title: t('Zone name'),
    },
    {
      key: 'location',
      title: t('Location'),
    },
    {
      key: 'numberOfWorkspaces',
      title: t('Workspace count'),
    },
  ]

  return <Table.Skeleton cols={cols} hasAccessory {...props} />
}
ZoneTable.Skeleton = Skeleton

export default ZoneTable
